/** Previous / Next across a long list.
 *
 *  The same three elements the laws, bills and members lists each spell out
 *  inline. Written as a component here because the organisations list had
 *  none at all: it printed "4,462 organisations have disclosed giving" and
 *  then stopped after 40 without saying so. */
export function Pager({
  page,
  pages,
  onPage,
  label = "Pagination",
}: {
  page: number;
  pages: number;
  onPage: (page: number) => void;
  label?: string;
}) {
  if (pages <= 1) return null;
  return (
    <nav className="mt-10 flex items-center justify-center gap-3" aria-label={label}>
      <button
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
        className="rounded-lg border border-line bg-card px-4 py-2 text-sm font-medium disabled:opacity-40"
      >
        ← Previous
      </button>
      <span className="tnum text-sm text-muted">
        {page} / {pages}
      </span>
      <button
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
        className="rounded-lg border border-line bg-card px-4 py-2 text-sm font-medium disabled:opacity-40"
      >
        Next →
      </button>
    </nav>
  );
}
